import React, { useEffect, useRef } from 'react';
import useFeatureFlags from 'store/authentication/useFeatureFlags';
import UIButton from 'components/UI/Button/Button';
import { func } from 'prop-types';
import useDebounce from 'utils/useDebounce';
import './InfiniteScroll.scss';

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 1.0,
};

function UIInfiniteScroll({ fetchMore }) {
  const containerRef = useRef();
  const observer = useRef();
  const debouncedFetchMore = useDebounce(fetchMore, 300, true);
  const featureFlags = useFeatureFlags();

  useEffect(() => {
    if (featureFlags?.regularPagination) {
      return () => {};
    }

    observer.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        debouncedFetchMore();
        observer.current.disconnect();
        observer.current = null;
      }
    }, options);
    observer.current.observe(containerRef.current);

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [debouncedFetchMore, observer, featureFlags]);

  if (!featureFlags?.regularPagination) {
    return <div ref={containerRef} />;
  }
  return (
    <div className="ui-infinite-scroll__load-more">
      <UIButton
        theme="bordered-light"
        onClick={() => {
          debouncedFetchMore();
        }}
      >
        Load more results
      </UIButton>
    </div>
  );
}

UIInfiniteScroll.propTypes = {
  fetchMore: func.isRequired,
};
UIInfiniteScroll.defaultProps = {};

export default UIInfiniteScroll;
